import type { StokAnalizReady } from "@/api/stok";
import { Ribbon } from "@/components/ui";
import { t } from "@/i18n";
import { fmtInt } from "@/lib/utils";

interface StokKapsamProps {
  satisaKapali: StokAnalizReady["satisa_kapali"];
  ciftKartlar: StokAnalizReady["cift_kartlar"];
}

/**
 * Analiz evreninden neyin cikarildigini/birlestirildigini seffaf gosteren
 * bilgi seridi (eski stok.js `renderKapsam`). Her iki veri de bos ise
 * (kart_sayisi=0 VE grup_sayisi=0) bant tamamen GIZLENIR (gorev sarti).
 */
export function StokKapsam({ satisaKapali, ciftKartlar }: StokKapsamProps) {
  const hasKapali = satisaKapali.kart_sayisi > 0;
  const hasCift = ciftKartlar.grup_sayisi > 0;
  if (!hasKapali && !hasCift) return null;

  return (
    <div data-testid="stok-kapsam-bandi">
      <Ribbon tone="info">
        <div className="space-y-1 text-sm font-normal">
          {hasKapali && (
            <p>
              {t("stok.kapsam.satisa_kapali", { adet: fmtInt(satisaKapali.kart_sayisi) })}
              {satisaKapali.stok_toplami > 0 &&
                ` — ${t("stok.kapsam.satisa_kapali_stok", { adet: fmtInt(satisaKapali.stok_toplami) })}`}
            </p>
          )}
          {hasCift && (
            <p>
              {ciftKartlar.birlestirildi
                ? t("stok.kapsam.cift_birlesti", { adet: fmtInt(ciftKartlar.grup_sayisi) })
                : t("stok.kapsam.cift_tespit", { adet: fmtInt(ciftKartlar.grup_sayisi) })}
            </p>
          )}
        </div>
      </Ribbon>
    </div>
  );
}
